<app-deal-details
  [deal]="deal"
  [approvals]="approvals"
  [advancedDeal]="advancedDeal"
>
</app-deal-details>
